import { useState } from "react";
import LoadingSpinner from "../../../LoadingSpinner";
import { MdOutlineBusinessCenter } from "react-icons/md";
import { formatFromJsonDate } from "../../../../dateConfig";

const VehicleStatusBasicInfo = ({
  jobCode,
  requestData,
  startLocation,
  endLocation,
  isLoading,
  activeTab,
}) => {
  const [activeAccordion2, setActiveAccordion2] = useState(true);

  return (
    <div
      style={{
        overflowY: "auto",
        height: "66vh",
        display: activeTab === "job" ? "flex" : "none",
        flexDirection: "column",
        alignItems: "flex-start",
        justifyContent: "flex-start",
        padding: "1px",
      }}
      className="basic-info"
    >
      <div className="ui styled accordion" style={{ width: "100%" }}>
        <div
          className={`title ${activeAccordion2 ? "active" : ""}`}
          onClick={() => setActiveAccordion2(!activeAccordion2)}
        >
          <div>
            <span>Job</span>
            <MdOutlineBusinessCenter size={14} style={{ marginLeft: "10px" }} />
            <i className="dropdown icon"></i>
          </div>
        </div>
        <div className={`content ${activeAccordion2 ? "active" : ""}`}>
          {isLoading ? (
            <LoadingSpinner />
          ) : (
            <div className="request-info">
              <h4 className="ui dividing header">Request Information</h4>
              <p>
                <span className="label">Request Code:</span>
                <span className="value">{requestData.reqCode}</span>
              </p>
              <p>
                <span className="label">Job Code:</span>
                <span className="value">{jobCode}</span>
              </p>
              <p>
                <span className="label">Request By:</span>
                <span className="value">{requestData.reqCreatedBy}</span>
              </p>
              <p>
                <span className="label">Request Date:</span>
                <span className="value">
                  {requestData.reqCreatedDate
                    ? formatFromJsonDate(requestData.reqCreatedDate)
                    : "N/A"}
                </span>
              </p>
              <p>
                <span className="label">Approved By:</span>
                <span className="value">{requestData.reqApprovedBy}</span>
              </p>
              <p>
                <span className="label">Approved Date:</span>
                <span className="value">
                  {requestData.reqApprovedDate
                    ? formatFromJsonDate(requestData.reqApprovedDate)
                    : "N/A"}
                </span>
              </p>
              <p>
                <span className="label">Start location:</span>
                <span className="value" style={{ textAlign: "right" }}>
                  {startLocation}
                </span>
              </p>
              <p>
                <span className="label">End Location:</span>
                <span className="value" style={{ textAlign: "right" }}>
                  {endLocation}
                </span>
              </p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default VehicleStatusBasicInfo;
